import {
  // PhoneInTalk,
  RecyclingRounded,
  EmojiEvents,
  Person,
} from '@mui/icons-material'

const entrypoint = process.env.REACT_APP_API_PLATFORM_ENDPOINT

const FITNESS_METRICS = {
  newLeads: {
    label: 'New Leads',
    colour: '#ff2d55',
    radius: 42,
    icon: Person,
  },

  salvageBooked: {
    label: 'Salvage',
    colour: '#a855f7',
    radius: 32,
    icon: EmojiEvents,
  },

  scrapBooked: {
    label: 'Scrap',
    colour: '#22c55e',
    radius: 22,
    icon: RecyclingRounded,
  },
}

// Commented out for v1 release
const TRACKED_METRICS = {
  ...FITNESS_METRICS,

  // talkTime: {
  //   label: 'Talk Time',
  //   colour: '#f59e0b',
  //   icon: PhoneInTalk,
  // },
}

const BADGE_TIERS = [
  {
    minPercent: 150,
    label: 'Legend',
    colour: '#fbbf24',
  },
  {
    minPercent: 125,
    label: 'On Fire',
    colour: '#ff9800',
  },
  {
    minPercent: 100,
    label: 'Crushing It',
    colour: '#22c55e',
  },
]

// allowed users (in order) - Jez, Harry, Dan, Ryan, Jack D, Jamie Steel, Arse ahmed, Keith, Connor F R, Connor Curry
const FITNESS_TRACKER_USERS = new Set([
  '1',
  '2',
  '16',
  '17',
  '100',
  '149',
  '179',
  '1240',
  '1333',
  '1346',
])

const canUseFitnessTracker = (userId) =>
  FITNESS_TRACKER_USERS.has(String(userId))

const formatTimeRemaining = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
}

const formatDuration = (seconds) => {
  const hrs = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds % 3600) / 60)

  if (hrs > 0) {
    return `${hrs}h ${mins}m`
  }

  return `${mins}m`
}

const formatHour = (hourString) => {
  const [hours, minutes] = hourString.split(':').map(Number)

  const period = hours >= 12 ? 'pm' : 'am'
  const hour12 = hours % 12 || 12

  return `${hour12}:${minutes.toString().padStart(2, '0')}${period}`
}

const EMPTY_HOUR = {
  newLeads: { value: 0, target: 0 },
  scrapBooked: { value: 0, target: 0 },
  salvageBooked: { value: 0, target: 0 },
  talkTime: { value: 0, target: 0 },
}

const build24HourDay = () =>
  Array.from({ length: 24 }, (_, hour) => ({
    hour: `${String(hour).padStart(2, '0')}:00`,
    ...EMPTY_HOUR,
  }))

const mergeHours = (apiHours = []) => {
  const fullDay = build24HourDay()

  apiHours.forEach((hourData) => {
    const index = Number(hourData.hour.split(':')[0])

    fullDay[index] = hourData
  })

  return fullDay
}

const getFitnessStats = async () => {
  const response = await fetch(
    new Request(`${entrypoint}/services/fitness/stats`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
  )

  const data = await response.json()

  if (data.Error) {
    throw new Error(data.Error)
  }

  return data
}

export {
  FITNESS_METRICS,
  TRACKED_METRICS,
  BADGE_TIERS,
  EMPTY_HOUR,
  canUseFitnessTracker,
  build24HourDay,
  formatDuration,
  formatHour,
  formatTimeRemaining,
  getFitnessStats,
  mergeHours,
}
